<script setup>

const props = defineProps({
    icon: {
        required: true,
        type: String
    },
    heading: {
        required: true,
        type: String
    },
    content: {
        required: true,
        type: String
    }
})

</script>

<template>
    <div class="empty-state">
        <div class="large-icon">
            <ah-icon :name="icon"/>
        </div>
        <dl>
            <dt>{{ heading }}</dt>
            <dd>{{ content }}</dd>
        </dl>
    </div>
</template>

<style lang="scss">

main:has(.empty-state) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    gap: 2rem;

    .large-icon {
        width: 8rem;
        height: 8rem;
        border-radius: 2.4rem;
        background: var(--color-theme-primary);
        display: flex;
        justify-content: center;
        align-items: center;

        .icon {
            fill: #fff;
        }
    }

    dt {
        margin-bottom: 1rem;
        @include font(2.2, 2.8, black);
        color: var(--color-grey-thunder);
    }

    dd {
        @include font(1.4, 2.4, null);
        color: var(--color-grey-thunder);
    }

    @include dark() {
        dt, dd {
            color: var(--color-white-100);

        }
    }
}
</style>
